import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { RequestResponse } from '../model/dto/RequestResponse';

@Injectable()
export class RestockReportService {
    private _urlBase: string;
    private _httpClient: HttpClient;

    constructor(http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
        this._urlBase = baseUrl;
        this._httpClient = http;
    }

    GetRestock(type: string, catStoreId: number, startDate: string, endDate: string, orgId: string): Observable<RequestResponse<any[]>> {

        let params = new HttpParams();
        params = params.append('type', type);
        params = params.append('catStoreId', catStoreId.toString());
        params = params.append('startDate', startDate);
        params = params.append('endDate', endDate);
        params = params.append('organizationId', orgId);

        return this._httpClient.get<RequestResponse<any[]>>(this._urlBase + 'api/Restock/RestockGet', { params: params });
    }

}
